const styles = {
    container: {
        width: '100%',
        maxWidth: '900px',
        margin: '0 auto',
        padding: '32px 24px',
        position: 'relative'
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '24px',
        marginBottom: '32px',
        position: 'relative',
        minHeight: '350px'  
    },
    dropzone: {
        borderWidth: '2px',
        borderStyle: 'dashed',
        borderColor: '#cbd5e1',
        borderRadius: '12px',
        padding: '48px 24px',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.7s ease-out',
        backgroundColor: '#ffffff',
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 2  
    },
    dropzoneActive: {
        borderColor: '#3b82f6',
        backgroundColor: '#f0f9ff',
        borderWidth: '2px',
        transform: 'scale(1.015)',
        boxShadow: '0 20px 25px -5px rgba(59, 130, 246, 0.2), 0 10px 10px -5px rgba(59, 130, 246, 0.15)'
    },
    previewTitle: {
        fontSize: '1.125rem',
        fontWeight: '600',
        marginBottom: '16px',
        color: '#1e293b',
        letterSpacing: '-0.01em'
    },
    hiddenInput: {
        display: 'none'
    },
    icon: {
        width: '48px',
        height: '48px',
        margin: '0 auto 16px',
        color: '#3b82f6',
        strokeWidth: 1.5,
        transition: 'all 0.7s ease-out'
    },
    title: {
        fontSize: '1.25rem',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '8px',
        transition: 'all 0.7s ease-out'
    },
    subtitle: {
        fontSize: '0.875rem',
        color: '#64748b',
        marginBottom: '4px',
        transition: 'color 0.5s ease-out'
    },
    fileTypes: {
        fontSize: '0.8125rem',
        color: '#94a3b8',
        marginTop: '8px'
    },
    removeButton: {
        color: '#ef4444',
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        padding: '6px',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease'
    },
    uploadButton: {
        backgroundColor: '#3b82f6',
        color: 'white',
        border: 'none',
        padding: '12px 24px',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: '600',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        width: '100%',
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 8px rgba(59, 130, 246, 0.2)'
    },
    uploadButtonDisabled: {
        backgroundColor: '#94a3b8',
        cursor: 'not-allowed',
        boxShadow: 'none'
    },
    progressContainer: {
        marginTop: '16px'
    },
    progressBar: {
        width: '100%',
        height: '6px',
        backgroundColor: '#e2e8f0',
        borderRadius: '999px',
        overflow: 'hidden'
    },
    progressFill: {
        height: '100%',
        backgroundColor: '#3b82f6',
        transition: 'width 0.5s ease-out',
        borderRadius: '999px'
    },
    uploadStatus: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '0.875rem',
        marginTop: '12px',
        padding: '10px 12px',
        borderRadius: '6px',
        backgroundColor: '#f8fafc',
        transition: 'all 0.4s ease-out'
    },
    success: {
        color: '#059669',
        backgroundColor: '#ecfdf5',
        border: '1px solid #d1fae5'
    },
    error: {
        color: '#dc2626',
        backgroundColor: '#fef2f2',
        border: '1px solid #fee2e2'
    },
    fileList: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    fileItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px',
        backgroundColor: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        marginBottom: '8px',
        transition: 'all 0.3s ease'
    },
    fileName: {
        fontSize: '0.9375rem',
        color: '#1e293b',
        display: 'flex',
        alignItems: 'center',
        fontWeight: '500',
        gap: '10px'
    },
    fileNameText: {
        marginRight: '8px'
    },
    removeIcon: {
        cursor: 'pointer',
        color: '#ef4444',
        padding: '6px',
        borderRadius: '6px',
        transition: 'all 0.2s ease'
    },
    successIcon: {
        color: '#10b981',
        marginRight: '8px'
    },
    pendingIcon: {
        color: '#f59e0b',
        marginRight: '8px'
    },
    warningIcon: {
        color: '#eab308',
        marginRight: '8px'
    },
    errorIcon: {
        color: '#ef4444',
        marginRight: '8px'
    },
    tooltip: {
        position: 'absolute',
        bottom: '100%',
        right: '0',
        backgroundColor: '#334155',
        color: '#ffffff',
        borderRadius: '6px',
        padding: '6px 12px',
        marginBottom: '6px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
        fontSize: '0.8125rem',
        textAlign: 'right',
        direction: 'rtl',
        zIndex: 10,
        whiteSpace: 'nowrap'
    },
    uploadedSection: {
        marginTop: '24px',
        marginBottom: '24px'
    },
    fileItemContainer: {
        position: 'relative',
        marginBottom: '10px'
    },
    fileItemApproved: {
        backgroundColor: '#f0fdf4',
        borderColor: '#bbf7d0'
    },
    fileItemPending: {
        backgroundColor: '#fffbeb',
        borderColor: '#fde68a'
    },
    fileItemRejected: {
        backgroundColor: '#fef2f2',
        borderColor: '#fecaca'
    },
    fileItemProcessing: {
        backgroundColor: '#eff6ff',
        borderColor: '#bfdbfe'
    },
};

export default styles;